interface powerupEllipseProps {
    onClick: any;
    showDropdown: boolean;
    powerupCount: number;
}

export const PowerupEllipse: React.FC<powerupEllipseProps> = ({
    onClick,
    showDropdown,
    powerupCount,
}) => {
    return (
        <div
            className="flex flex-row items-center justify-center cursor-pointer"
            onClick={onClick}
        >
            <div className="w-10 h-10 rounded-full">
                <img
                    src={"/assets/images/powerup-ellipse.png"}
                    alt="powerup"
                    className="object-contain w-full h-full"
                />
                <span
                    className="absolute top-1 px-2 py-1 font-bold text-white rounded-full left-10 bg-coral-red"
                    style={{ fontSize: "0.6rem" }}
                >
                    {powerupCount}
                </span>
            </div>
            <div className="w-3 h-2 ml-2">
                <img
                    src={"/icons/chevron-down.png"}
                    alt=">"
                    className={
                        "object-contain w-full h-full " +
                        " " +
                        (showDropdown
                            ? "transform origin-center rotate-180"
                            : "")
                    }
                />
            </div>
        </div>
    );
};
